@if (filteredTrackers.length) {
  <mat-card appearance="outlined" class="tracker-section">
    <mat-card-header>
      <mat-card-title-group>
        <mat-card-title>{{this.outletReviewCategory.name}}</mat-card-title>
      </mat-card-title-group>
    </mat-card-header>
    <mat-card-content>
      <table mat-table [dataSource]="dataSource" class="stripped-table">
        <ng-container matColumnDef="row">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let item;">{{item.row}}.</td>
          <td mat-footer-cell *matFooterCellDef>Totals</td>
        </ng-container>
        <ng-container matColumnDef="project">
          <th mat-header-cell *matHeaderCellDef>Deal</th>
          <td mat-cell *matCellDef="let item">
            <a [href]="item.projectUrl" target="_blank">{{item.projectName}}</a>
            @if (item.funds.length) {
              <span class="sub">
                (3rd Party Review Required for @for (fund of item.funds; track fund; let i = $index) {
                {{i > 0 ? ', ' : ''}}<a [href]="fund | objectLink">{{fund.name}}</a>
                })
              </span>
            }
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="category">
          <th mat-header-cell *matHeaderCellDef>Category</th>
          <td mat-cell *matCellDef="let item">
            <select [(ngModel)]="item.outlet_review_category_id" (change)="updateField(item.outlet_review_tracker_id, 'outlet_review_category_id', $event)" [disabled]="!(permission | permission: '_edit' )">
              @for (category of outletReviewCategories; track category) {
                <option [value]="category.id">{{category.name}}</option>
              }
            </select>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="city">
          <th mat-header-cell *matHeaderCellDef>City</th>
          <td mat-cell *matCellDef="let item">{{item.city ?? '\u2014'}}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="state">
          <th mat-header-cell *matHeaderCellDef>State</th>
          <td mat-cell *matCellDef="let item">{{item.state ?? '\u2014'}}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="sponsor">
          <th mat-header-cell *matHeaderCellDef>Primary Sponsor</th>
          <td mat-cell *matCellDef="let item">
            @if (item.sponsorName) {
              <a target="_blank" [href]="item.sponsorUrl">{{item.sponsorName}}</a>
            }
            @if (!item.sponsorName) {
              <span>&mdash;</span>
            }
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="deal_status">
          <th mat-header-cell *matHeaderCellDef>Deal Status</th>
          <td mat-cell *matHeaderCellDef></td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="cohn_reznick_review">
          <th mat-header-cell *matHeaderCellDef>Cohn Reznick Review Status</th>
          <td mat-cell *matCellDef="let item">
            <select [(ngModel)]="item.cohn_reznick_review_status_id" (change)="updateField(item.outlet_review_tracker_id, 'cohn_reznick_review_status_id', $event)" [disabled]="!(permission | permission: '_edit' )">
              @for (status of outletReviewStatuses; track status) {
                <option [value]="status.id">{{status.name}}</option>
              }
            </select>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="third_party_review_date">
          <th mat-header-cell *matHeaderCellDef>3rd Party Review Date Completed</th>
          <td mat-cell *matCellDef="let item">
            @if ((permission | permission: '_edit' )) {
              <input type="date" [value]="item.third_party_review_date_completed" (change)="dateChange.next({tracker:item.outlet_review_tracker_id, event:$event, key:'third_party_review_date_completed'})">
            }
            @if (!(permission | permission: '_edit' )) {
              <span>{{item.third_party_review_date_completed ? (item.third_party_review_date_completed | date: 'MM/dd/yyyy' ) : '\u2014'}}</span>
            }
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="crea_committee_memo_status">
          <th mat-header-cell *matHeaderCellDef>CREA Committee Memo Status</th>
          <td mat-cell *matCellDef="let item">
            <select [(ngModel)]="item.committee_memo_status_id" (change)="updateField(item.outlet_review_tracker_id, 'committee_memo_status_id', $event)" [disabled]="!(permission | permission: '_edit' )">
              @for (status of outletReviewStatuses; track status) {
                <option [value]="status.id">{{status.name}}</option>
              }
            </select>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="equity">
          <th mat-header-cell *matHeaderCellDef>Equity</th>
          <td mat-cell *matCellDef="let item">{{item.equity | currency:"USD" : "symbol" : "1.0"}}</td>
          <td mat-footer-cell *matFooterCellDef>{{sectionTotal | currency:"USD" : "symbol" : "1.0"}}</td>
        </ng-container>
        <ng-container matColumnDef="percentage">
          <th mat-header-cell *matHeaderCellDef>% of Gross Equity</th>
          <td mat-cell *matCellDef="let item">{{item.percentage | percent:"1.2"}}</td>
          <td mat-footer-cell *matFooterCellDef>{{sectionTotalPercent | percent:"1.2"}}</td>
        </ng-container>
        <ng-container matColumnDef="cumulative">
          <th mat-header-cell *matHeaderCellDef>Cumulative</th>
          <td mat-cell *matCellDef="let item">{{item.cumulative | percent:"1.2"}}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Deal Status</th>
          <td mat-cell *matCellDef="let item">{{item.status}}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="report_distributed">
          <th mat-header-cell *matHeaderCellDef>Executive Report Distributed to Investors per LPA</th>
          <td mat-cell *matCellDef="let item">
            @if ((permission | permission: '_edit' )) {
              <span class="radio-wrap">
                <span class="radio-group">
                  <input (change)="updateField(item.outlet_review_tracker_id, 'executive_report_distributed', true)" id="yes-{{item.row}}" name="report_distributed_{{item.row}}" type="radio" [defaultChecked]="item.executive_report_distributed"/>
                  <label for="yes-{{item.row}}">Yes</label>
                </span>
                <span class="radio-group">
                  <input (change)="updateField(item.outlet_review_tracker_id, 'executive_report_distributed', false)" id="no-{{item.row}}" name="report_distributed_{{item.row}}" type="radio" [defaultChecked]="item.executive_report_distributed === false"/>
                  <label for="no-{{item.row}}">No</label>
                </span>
              </span>
            }
            @if (!(permission | permission: '_edit' )) {
              <span>{{item.executive_report_distributed | yesno}}</span>
            }
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="investment_committee_date">
          <th mat-header-cell *matHeaderCellDef=>Investment Committee Date</th>
          <td mat-cell *matCellDef="let item">
            <span class="investment-committee-wrap">
              <span class="date" [matTooltip]="item.committee_date ? (item.committee_is_target ? 'Target Date' : 'Actual Date'):''">
                @if (item.committee_date) {
                  <mat-icon [class]="{target:item.committee_is_target}">{{item.committee_is_target ? "flare" : "check"}}</mat-icon>
                }
                <span>{{item.committee_date ? (item.committee_date | date: "MM/dd/yyyy") : "\u2014"}}</span>
              </span>
              @if ((permission | permission: '_edit' )) {
                <span>
                  <input type="date" [value]="item.investor_committee_date" (change)="dateChange.next({tracker:item.outlet_review_tracker_id, key:'investor_committee_date', event:$event})">
                </span>
              }
              @if (!(permission | permission: '_edit' )) {
                <span>
                  {{item.investor_committee_date | date: "MM/dd/yyyy"}}
                </span>
              }
            </span>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="close_date">
          <th mat-header-cell *matHeaderCellDef>Projected Closing Date</th>
          <td mat-cell *matCellDef="let item">
            <span class="date" [matTooltip]="item.close_date ? (item.close_is_target ? 'Target Date' : 'Actual Date'):''">
              @if (item.close_date) {
                <mat-icon [class]="{target:item.close_is_target}">{{item.close_is_target ? "flare" : "check"}}</mat-icon>
              }
              <span>{{item.close_date ? (item.close_date | date: "MM/dd/yyyy") : "\u2014"}}</span>
            </span>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="analyst_assignment">
          <th mat-header-cell *matHeaderCellDef>Analyst Assignment</th>
          <td mat-cell *matCellDef="let item">
            @if (item.analystName) {
              <span class="analyst">
                <span class="person">{{item.analystName}}</span>
                @if ((permission | permission: '_edit' )) {
                  <a class="clear-button" href="#" (click)="$event.preventDefault();updateField(item.outlet_review_tracker_id, 'outlet_review_analyst_id', null)"><mat-icon>delete</mat-icon></a>
                }
              </span>
            }
            @if (!item.analystName && (permission | permission: '_edit' )) {
              <span>
                <!--              <employee-search (personChanged)="updateField(item.outlet_review_tracker_id, 'outlet_review_analyst_id', $event)"></employee-search>-->
                <analyst-search (personChanged)="updateField(item.outlet_review_tracker_id, 'outlet_review_analyst_id', $event)"></analyst-search>
              </span>
            }
            @if (!item.analystName && !(permission | permission: '_edit' )) {
              <span>
                &mdash;
              </span>
            }
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns:columns"></tr>
        <tr mat-footer-row *matFooterRowDef="columns" class="totals-row"></tr>
      </table>
    </mat-card-content>
  </mat-card>
}
